import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project import
import Loadable from 'components/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// render - pages
const LandingPage         = Loadable(lazy(() => import('pages/landing/LandingPage')));
const AuthLogin           = Loadable(lazy(() => import('pages/authentication/Login')));
const CandidateRegister   = Loadable(lazy(() => import('pages/authentication/CandidateRegister')));
const OtpLogin            = Loadable(lazy(() => import('pages/authentication/OtpLogin')));
const SuperAdminLogin     = Loadable(lazy(() => import('pages/authentication/SuperAdminLogin')));
const PublicPollVote      = Loadable(lazy(() => import('pages/kems/PublicPollVote')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      index: true,
      element: <LandingPage />
    },
    {
      path: 'login',
      element: <AuthLogin />
    },
    {
      path: 'register',
      element: <CandidateRegister />
    },
    {
      path: 'otplogin',
      element: <OtpLogin />
    },
    {
      path: 'admin/login',
      element: <SuperAdminLogin />
    },
    {
      path: 'vote/:token',
      element: <PublicPollVote />
    },
    {
      // Any unknown route while logged out → redirect to login
      path: '*',
      element: <Navigate to="/login" replace />
    }
  ]
};

export default LoginRoutes;
